<div>
	<div libFlexRow>
		<div libFlexColumn libFlexFill>
			<ui-select-item-field
				[placeholder]="'Select date...'"
				[isRequired]="true"
				[valueAsSignal]="selectedDate"
				[title]="'Date'"
				[items]="availableDatesSelectionList()"
			></ui-select-item-field>
		</div>
	</div>
</div>

<lib-divider class="push-top push-bottom"></lib-divider>

@if (progressValueFormInputs(); as progressValueFormInputs) {
<div>
	@for (progressFormInput of progressValueFormInputs; track progressFormInput.id; let first = $first) {
	<div [class.push-top]="!first">
		<ui-number-form-field
			[title]="progressFormInput.name"
			[isRequired]="false"
			[subtitle]="progressFormInput.subtitle"
			[valueAsSignal]="progressFormInput.value"
			(valueChange)="handleValueChange($event, progressFormInput)"
		></ui-number-form-field>
	</div>
	}

	<ui-form-save-button
		[title]="'Save'"
		[isInDialog]="isInDialog()"
		[saveHandler]="saveHandler()"
		[logHandler]="formLogHandler()"
	></ui-form-save-button>
</div>
}
